import { createReducer } from '@reduxjs/toolkit';
import { GetPoData, GetPOINVPINPUT, GetPoReceipt, GETPRODISSUE, GETPRODRECEIPT, GetTransaction, PostPOINVPINPUT, postProductionFGReceipt } from './ProductionFgThunk';


const handleAsyncActions = (builder, action, stateKey, errorKey) => {
  builder
    .addCase(action.pending, (state) => {
      state.loading[stateKey] = true; 
      state[stateKey] = null;
      state.error[errorKey] = null;
    })
    .addCase(action.fulfilled, (state, action) => {
      state.loading[stateKey] = false; // Set loading to false when request is fulfilled
      state[stateKey] = action.payload;             
      state.error[errorKey] = null; // Reset error
    })
    .addCase(action.rejected, (state, action) => {
      state.loading[stateKey] = false; // Set loading to false when request fails
      state.error[errorKey] = action.payload; // Set specific error message for the API call
    });
};

const initialState = {
  ProdFgData: null,
  // ProdFgReceipt:null,
  POINVPINPUT:null,
  POINVPINPUTPost:null,
  POReceiptInput:null,
  PRODReceipt:null,
  ProductionFGReceipt:null,
  ProdTransList:null,
  // Dynamic loading and error states for each API
  loading: {
    GetPoData: false,
    POReceiptInput:false,
    POINVPINPUT:false,
    POINVPINPUTPost:false,
    PRODReceipt:false,
    ProdTransList:false,
    ProductionFGReceipt:false,
  },

  error: {
    GetPoDataError: null,
    ProdIssueError:null,
    POINVPINPUTError:null,
    POINVPINPUTPostError:null,
    POReceiptINPUTDataError:null,
    ProductionFGReceiptError:null,
    ProdTransListError:null,
  },
};

export const ProductionFgReducer = createReducer(initialState, (builder) => {
//   Use the utility function to handle async actions
 handleAsyncActions(builder, GetPoData, "ProdFgData", "GetPoDataError");
 handleAsyncActions(builder, GETPRODISSUE, "ProductionFGIssue", "ProdIssueError");
 handleAsyncActions(builder, GetPOINVPINPUT, "POINVPINPUT", "POINVPINPUTError");
 handleAsyncActions(builder, PostPOINVPINPUT, "POINVPINPUTPost", "POINVPINPUTPostError");
 handleAsyncActions(builder, GETPRODRECEIPT, "PRODReceipt", "POReceiptINPUTDataError");
 handleAsyncActions(builder, postProductionFGReceipt, "ProductionFGReceipt", "ProductionFGReceiptError");
 handleAsyncActions(builder, GetTransaction, "ProdTransList", "ProdTransListError");
});

export default ProductionFgReducer;